module.exports = __webpack_public_path__ + "img/lefticon.84724104.svg";